function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function HomeIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M21 9.5V21H19V10.5L12.6001 5.69971C12.2476 5.43506 11.7529 5.43457 11.3994 5.7002L5.00001 10.4999V21H3V4H5V8L10.1997 4.1001C11.2607 3.30518 12.7407 3.30567 13.7998 4.09961L21 9.5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13.7 16.6V21H10.5V16.6C10.5 15.7163 11.2163 15 12.1 15C12.9837 15 13.7 15.7163 13.7 16.6Z",
    fill: "currentColor"
  }));
}
export function HomeIconSmall(props) {
  return ___EmotionJSX(HomeIcon, _extends({
    size: "small"
  }, props));
}